import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MasterComponent } from './pages/master/master.component';
import { RouterModule } from '@angular/router';
import { NgxsModule } from '@ngxs/store';
import { LayoutState } from './state/layout.state';
import { SiteHeaderComponent } from './components/site-header/site-header.component';
import { MaterialModule } from '../material.module';
import { SharedModule } from '../shared/shared.module';
import { ExploreMenuComponent } from './components/explore-menu/explore-menu.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LocaleConfigModule } from '../locale-config.module';
import { LocaleMenuComponent } from './components/locale-menu/locale-menu.component';
import { AuthModule } from '../auth/auth.module';
import { SearchFieldComponent } from './components/search-field/search-field.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MobileNavComponent } from './components/mobile-nav/mobile-nav.component';

@NgModule({
  imports: [
    AuthModule,
    SharedModule,
    MaterialModule,
    CommonModule,
    RouterModule,
    FontAwesomeModule,
    LocaleConfigModule,
    ReactiveFormsModule,
    NgxsModule.forFeature([
      LayoutState
    ])
  ],
  declarations: [
    MasterComponent,
    SiteHeaderComponent,
    ExploreMenuComponent,
    LocaleMenuComponent,
    SearchFieldComponent,
    MobileNavComponent
  ],
  exports: [MasterComponent]
})
export class LayoutModule { }
